import { FC } from 'react'
import { ConsentBanner, useCookieConsent } from '@sequencehq/core-components'
import { useConsentSync } from './useConsentSync'

export const DashboardConsentBanner: FC = () => {
  const { isBannerOpen, accept, reject } = useCookieConsent()

  useConsentSync()

  return (
    <ConsentBanner
      isOpen={isBannerOpen}
      onAccept={accept}
      onReject={reject}
      data-testid="dashboard.consentBanner"
    />
  )
}
